import ScrollHint from 'scroll-hint'
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      new ScrollHint(entry.target, {
        suggestiveShadow: true,
        i18n: {
          scrollable: "スクロールできます"
        }
      });
      observer.unobserve(entry.target);
    }
  });
});

document.querySelectorAll(".scrollArea").forEach(el => {
  observer.observe(el);
});